import { type DocumentReference } from '@principle-theorem/shared';
import { IAccClaimProviderDetails } from '../..';
import { IPractice } from '../practice/practice';

export type StafferMetadataValue = string | boolean | number | string[];

export type IStafferMetadata = Partial<ICustomMetadata> &
  Partial<INzStafferMetadata> &
  Partial<IHeidiStafferMetadata> &
  Partial<IAiScribeStafferMetadata>;

export type AccProviderDetails = Pick<
  IAccClaimProviderDetails,
  'providerId' | 'providerTypeCode'
>;

interface ICustomStafferMetadata {
  [key: string]: StafferMetadataValue;
}

interface ICustomMetadata {
  custom: ICustomStafferMetadata;
}

export interface INzStafferProviderDetails {
  dcnzNumber: string;
  acc: AccProviderDetails;
}

export interface INzStafferPracticeProviderDetails {
  practiceRef: DocumentReference<IPractice>;
  payeeNumber: string;
  agreementNumber: string;
}

export interface INzStafferMetadata {
  nz: {
    providerDetails: Partial<INzStafferProviderDetails>;
    practiceProviderDetails?: INzStafferPracticeProviderDetails[];
  };
}

export interface IHeidiStafferSettings {
  email?: string;
  useAsDefault?: boolean;
}

export interface IHeidiStafferMetadata {
  heidi: Partial<IHeidiStafferSettings>;
}

export interface IAiScribeStafferSettings {
  seatEnabled: boolean;
}

export interface IAiScribeStafferMetadata {
  aiScribe: Partial<IAiScribeStafferSettings>;
}
